export default __webpack_public_path__ + "static/media/solanato-qukes-tortilla-cups.20e448c3.jpg";